///<amd-module name="typeahead/core/geolocation/message/GeolocationResponseMessage" />

import {IPosition, IPositionError} from "typeahead/core/geolocation/GeolocationDataProvider";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {ISuggestionResult} from "typeahead/core/Suggestion";

export class GeolocationResponseMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.geolocation_response";
    }

    constructor(private domElementId: string, private position: IPosition, private postionError: IPositionError,
                private geolocationResult: ISuggestionResult, private submitButton: JQuery = undefined) {}

    public getTopic(): string {
        return GeolocationResponseMessage.getTopic();
    }

    public getPosition(): IPosition {
        return this.position;
    }

    public getPositionError(): IPositionError {
        return this.postionError;
    }

    public getGeolocationResult(): ISuggestionResult {
        return this.geolocationResult;
    }

    public getSubmitButton(): JQuery {
        return this.submitButton;
    }

    public getDomElementId(): string {
        return this.domElementId;
    }
}
